<template>
	<by-container :showLoading="showLoading" :showNotContent="showNotContent">
		<div class="wrap clearfloat">
			<div class="aboutTit">
				<ul>
					<li v-for="(nav,index) in items" :key="index" :class="[(!$route.query.type && nav.type == '') || nav.type == $route.query.type ? 'active' : '']">
						<router-link :to="{ name: nav.src, query: { type: nav.type }}">{{nav.title}}</router-link>
					</li>
				</ul>
			</div>
			<div class="notic">
				<ul class="noticList clearfloat">
					<byNewsItem v-for="(li,index) in list" :key="index" :itemData="li"></byNewsItem>
				</ul>
				
				 <el-pagination
						 class="page pageNews"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="current"
						:page-size="size"
						layout="total, prev, pager, next"
						:total="total">
    		</el-pagination>
			</div>
		</div>
	</by-container>
</template>

<script>
import byNewsItem from "@/components/item/news_1.vue";
export default {
	components: {
		// 引入组件
		byNewsItem
	},
	data() {
		return {
			showLoading: false, //页面加载状态
			showNotContent: false ,//是否显示空

			current:1,
			size:6,
			total:0,

			items:[
				{ title:"全部资讯",src:"news",type:"",checked:true, },
				{ title:"本地资讯",src:"news",type:'news',checked:false, },
				{ title:"通知公告",src:"news",type:'notice',checked:false, },
				{ title:"重要政策",src:"news",type:'policy',checked:false, },
			],
			list:[],
			
		
		};
	},
	props: {
		// 上级页面传递的数据
	},
	computed: {
		// 计算属性
	},
	created() {
		// 实例初始化
		
	},
	beforeCreate() {
		// 实例初始化之后
	},
	mounted() {
		// 实例被挂载后调用
		this.getAll()
	},
	updated() {
		// 数据更新后调用
	},
	activated() {
		// 缓存页面显示后调用
	},
	deactivated() {
		// 缓存页面隐藏后调用
	},
	methods: {
		// 获取全部
		getAll(){
			let reqInfo = {};
			reqInfo.current = this.current;
			reqInfo.size = this.size;
			reqInfo.type = this.$route.query.type || '';
			reqInfo.showContent = 1;
			this.$api.Home.getNotices(reqInfo,res => {
				let resData = res.data.records;
				this.list = resData;
				this.total = res.data.total
			},err=>{
				console.log(err)
			})
		},
		handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.current = val
			this.getAll()
		}
	},
	watch: {
		// 数据监听及回调
		$route(){
			 this.current = 1;
			 this.getAll()	
  	},
	}
};
</script>

<style scoped="scoped"></style>
